import { GatsbyLinkProps, Link } from 'gatsby';
import * as React from 'react';
import { useLang } from './localize-context';

type LangLinkProps = Omit<GatsbyLinkProps<any>, 'ref'>;

/**
 * Custom Link that will direct to the correct url based on current language.
 */
export const LangLink = ({ to, ...props }: LangLinkProps) => {
  const lang = useLang();

  return <Link to={lang === 'en-us' ? to : `/zh${to}`} {...props} />;
};
